/* eslint-disable no-unused-vars */
// eslint-disable-next-line import/no-unresolved
import { h, Component } from 'preact';
import PropTypes from 'prop-types';
import handleInputChange from '%/utils/handleInputChange';
import { getPayload } from '%/utils/forms/getPayload';
import { mask } from '%/utils/formUtils/maks/mask';
import validationFactory from '%/utils/validation';
import FormWrapper from '../FormComponents/FormWrapper';
import FormMessageOverlay from '../../FormMessageOverlay';
import FormHeader from '../FormComponents/FormHeader';
import FormBody from '../FormComponents/FormBody';
import Input from '../FormComponents/Fields/Input';
import Select from '../FormComponents/Fields/Select';
import Textarea from '../FormComponents/Fields/Textarea';
import ContactFieldGroup from '../FormComponents/Fields/ContactFieldGroup';
import Checkbox from '../FormComponents/Fields/Checkbox';
import FieldGroup from '../FormComponents/FieldGroup';
import FormFooter from '../FormComponents/FormFooter';
import SubmitButton from '../FormComponents/SubmitButton';
import { setRecaptchaLoadOnFormFocus } from '../../../utils/reCAPTCHA';

export default class ConversionFormV2 extends Component {
  constructor(props) {
    super(props);

    this.initialState = {
      name: null,
      email: null,
      phone: null,
      cpf: '',
      unit: null,
      mailing: null,
      whatsapping: null,
      phoning: null,
      dataPermissions: false,
      formState: {
        isSubmitting: false,
        errorSending: false,
        showOverlay: false,
      },
      message: null,
    };

    this.state = this.initialState;

    this.handleInputChange = handleInputChange.bind(this);
    this.handleCloseOverlay = this.handleCloseOverlay.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.resetFormInputs = this.resetFormInputs.bind(this);
  }

  componentDidMount() {
    if (this.phoneInput) {
      mask(this.phoneInput, { mask: 'phone' }, phoneMaskvalue =>
        this.setState({ phone: phoneMaskvalue }),
      );
    }

    if (this.cpfInput) {
      mask(this.cpfInput, { mask: 'cpf' }, cpfMaskValue =>
        this.setState({ cpf: cpfMaskValue }),
      );
    }

    this.validator = validationFactory(`#${this.props.formId}`);
    setRecaptchaLoadOnFormFocus();
  }

  handleSubmit(event) {
    event.preventDefault();

    const invalidInputs = this.validator.validateAll(this.form);
    const formIsValid = invalidInputs.length === 0;
    if (!formIsValid) return;

    const customParams = {
      product: this.props.product || this.props.keyword,
    };

    const payload = {
      ...getPayload(this.state, this.props),
      ...customParams,
    };

    this.setState({
      formState: { isSubmitting: true },
    });

    window.serviceConversion
      .convert(payload)
      .then(() => {
        this.setState({
          formState: {
            isSubmitting: false,
            errorSending: false,
          },
        });
        return {
          data: payload,
          status: 'success',
        };
      })
      .catch(error => {
        this.setState({
          formState: {
            isSubmitting: false,
            errorSending: true,
          },
        });
        console.error(error);
        return {
          data: error,
          status: 'error',
        };
      })
      .then(result => {
        document.dispatchEvent(
          new CustomEvent('new_conversion', {
            detail: {
              status: result.status,
              data: result.data,
            },
          }),
        );
        this.setState({ formState: { showOverlay: true } });
      });
  }

  handleCloseOverlay() {
    this.setState({ formState: { showOverlay: false } });
    this.resetFormInputs();
  }

  resetFormInputs() {
    this.state = this.initialState;
  }

  render() {
    const {
      formId,
      showCpf,
      showUnits,
      showDataPermissions,
      dataPermissionsCustomText,
      linkPrivacyPolicy,
      units,
      submitButtonLabel,
      showMessageField,
    } = this.props;

    return (
      <FormWrapper
        customClasses="conversion-form--no-result"
        formId={formId}
        setRef={form => {
          this.form = form;
        }}
        handleSubmit={this.handleSubmit}
      >
        <FormMessageOverlay
          handleClose={this.handleCloseOverlay}
          isVisible={this.state.formState.showOverlay}
          type={this.state.formState.errorSending ? 'error' : 'success'}
        />
        <FormHeader
          title="Não encontrou o que procurava?"
          subtitle="Preencha o formulário abaixo e um de nossos consultores entrarão em contato para te ajudar."
        />
        <FormBody>
          <FieldGroup>
            <Input
              title="Nome"
              name="name"
              value={this.state.name}
              type="text"
              placeholder="Nome"
              handleChange={this.handleInputChange}
              required
            />
            <Input
              title="E-mail"
              name="email"
              value={this.state.email}
              type="email"
              placeholder="E-mail"
              handleChange={this.handleInputChange}
              required
            />
            <Input
              title="Telefone"
              name="phone"
              value={this.state.phone}
              type="phone"
              autoComplete="off"
              placeholder="Telefone/Whatsapp"
              handleChange={this.handleInputChange}
              setRef={phoneInput => {
                this.phoneInput = phoneInput;
              }}
              required
            />
            {showCpf && (
              <Input
                title="CPF"
                name="cpf"
                value={this.state.cpf}
                type="text"
                placeholder="CPF"
                handleChange={this.handleInputChange}
                setRef={cpfInput => {
                  this.cpfInput = cpfInput;
                }}
                required
                minLength={14}
              />
            )}
            {showUnits && (
              <Select
                name="unit"
                options={units}
                label="Escolha a unidade:"
                placeholder="Selecione uma unidade"
                handleChange={this.handleInputChange}
              />
            )}
            {showMessageField && (
              <Textarea
                name="message"
                placeholder="Mensagem"
                rows="1"
                handleChange={this.handleInputChange}
                value={this.state.message}
              />
            )}
          </FieldGroup>
          <ContactFieldGroup
            handleChange={this.handleInputChange}
            mailing={this.state.mailing}
            whatsapping={this.state.whatsapping}
            phoning={this.state.phoning}
          />
          {showDataPermissions && (
            <FieldGroup>
              <Checkbox
                label={dataPermissionsCustomText}
                name="dataPermissions"
                value={this.state.dataPermissions}
                isChecked={this.state.dataPermissions}
                customClasses="form__field-checkbox-data-permissions"
                handleChange={this.handleInputChange}
              />
            </FieldGroup>
          )}
          <FormFooter linkPrivacyPolicy={linkPrivacyPolicy} />
          <SubmitButton
            label={submitButtonLabel}
            isSubmitting={this.state.formState.isSubmitting}
          />
        </FormBody>
      </FormWrapper>
    );
  }
}

ConversionFormV2.defaultProps = {
  submitButtonLabel: 'Estou interessado',
  showMessageField: false,
};

ConversionFormV2.propTypes = {
  formId: PropTypes.string.isRequired,
  showCpf: PropTypes.bool,
  showUnits: PropTypes.bool,
  showDataPermissions: PropTypes.bool,
  dataPermissionsCustomText: PropTypes.string,
  linkPrivacyPolicy: PropTypes.string,
  keyword: PropTypes.string,
  product: PropTypes.string,
  units: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string,
      value: PropTypes.string,
    }),
  ),
  submitButtonLabel: PropTypes.string,
  showMessageField: PropTypes.bool,
};
